import NumberUtils from '@/utils/number.utils';

import useOfferCountdown from '../hooks/useOfferCountdown';

import './ArtworkOfferElements.css';

function formatOfferPrice(value, currency) {
  return NumberUtils.getOfferPrice(value, currency || 'EUR');
}

export function ArtworkOfferPrice({
  originalPrice,
  offerPrice,
  currency,
  className = '',
}) {
  const originalDisplay = formatOfferPrice(originalPrice, currency);
  const offerDisplay = formatOfferPrice(offerPrice, currency);

  if (!offerDisplay) {
    return originalDisplay ?? null;
  }

  const classes = className
    ? `artwork-offer-price ${className}`
    : 'artwork-offer-price';

  return (
    <span className={classes}>
      {originalDisplay ? (
        <span className="artwork-offer-price__original">{originalDisplay}</span>
      ) : null}
      <span className="artwork-offer-price__current-row">
        <span className="artwork-offer-price__current">{offerDisplay}</span>
      </span>
    </span>
  );
}

export function ArtworkOfferCountdown({
  expiresAt,
  className = '',
  compact = false,
}) {
  const { value, label, status } = useOfferCountdown(expiresAt);

  if (!label) {
    return null;
  }

  const classes = [
    'artwork-offer-countdown',
    compact ? 'artwork-offer-countdown--compact' : '',
    status ? `artwork-offer-countdown--${status}` : '',
    className,
  ].filter(Boolean).join(' ');

  if (compact) {
    return (
      <span className={classes}>
        <span className="artwork-offer-countdown__text">{label}</span>
      </span>
    );
  }

  return (
    <span className={classes}>
      <span className="artwork-offer-countdown__eyebrow">Exclusive offer</span>
      <span className="artwork-offer-countdown__text">Ends in {value}</span>
    </span>
  );
}
